
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import RegisterModal from "@/components/modals/RegisterModal";
import { useTranslation } from 'react-i18next';

const Hero = () => {
  const { t } = useTranslation();

  return (
    <section 
      className="text-center space-y-6 py-8 md:py-16 animate-fade-in" 
      aria-labelledby="hero-heading"
    >
      <h1 
        id="hero-heading" 
        className="text-4xl md:text-5xl font-bold max-w-3xl mx-auto leading-tight"
      >
        {t('home.hero_title_part1')}{" "}
        <span className="gradient-blue-purple-text">
          {t('home.hero_title_accessible')}
        </span>
      </h1>
      <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
        {t('home.hero_description')}
      </p>
      <div className="flex flex-col md:flex-row gap-4 justify-center">
        <RegisterModal>
          <Button 
            size="lg"
            className="gradient-cta-button"
            aria-label={t('home.cta_start_now_aria')}
          >
            {t('home.cta_start_now')}
          </Button>
        </RegisterModal>
        <Button 
          variant="outline" 
          size="lg" 
          asChild
          aria-label={t('home.cta_how_it_works_aria')}
        >
          <Link to="/how-it-works">{t('home.cta_how_it_works')}</Link>
        </Button>
      </div>
      <div className="mt-10 relative w-full max-w-4xl mx-auto">
        <div 
          className="absolute -inset-4 rounded-xl gradient-blue-purple blur-xl opacity-30"
          aria-hidden="true"
        ></div>
        <img 
          src="https://images.unsplash.com/photo-1573497620053-ea5300f94f21?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" 
          alt={t('home.hero_image_alt')} 
          className="w-full rounded-lg shadow-md relative z-10" 
          loading="eager"
          fetchPriority="high"
          width="1200"
          height="675"
        />
      </div>
    </section>
  );
};

export default Hero;
